<template>
    <div class="video-stub">
        <div class="video-stub__top">
            <div class="title" v-html="$t('message.video_stub_title')"></div>
            <div class="logo">
                <svg>
                    <use xlink:href="#ic_logo-no-frame"></use>
                </svg>
            </div>
        </div>
        <div class="video-stub__text" v-html="$t('message.video_stub_text')"></div>
    </div>
</template>

<script>

export default {
    props: {
    },

    data() {
        return {

        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    computed: {

    },

    methods: {

    }
}
</script>

<style scoped>

</style>
